import { color, fontSize, space } from '@core-ds/primitives';
import { Icon } from '@ifixit/toolbox';
import React from 'react';
import styled from 'styled-components';

const PopupContainer = styled.div`
   display: flex;
   flex-direction: column;
   background: ${color.white};
   padding: ${space[4]};
   box-shadow: 0 2px 4px rgba(16, 22, 26, 0.2), 0 6px 18px rgba(16, 22, 26, 0.2);
   border-radius: 4px;
   margin: ${space[3]} 0;
   text-align: left;
   font-size: ${fontSize[1]};
`;

const TextContainer = styled.div`
   margin: 0;
   color: ${color.gray7};
`;

const WarningHeader = styled.div`
   display: flex;
   font-size: ${fontSize[1]};
   font-weight: bold;
   color: ${color.gray8};
   justify-content: space-between;
   align-items: center;
   letter-spacing: 1px;
`;

const WarningContainer = styled.div`
   display: flex;
   align-items: center;
`;

const AlertTriangle = styled(Icon).attrs({ name: 'alert-triangle' })`
   svg {
      color: ${color.black};
      fill: ${color.yellowLight2};
   }
`;

const Button = styled.button`
   background: none;
   border: 0;
   padding: 0;
   appearance: none;
   cursor: pointer;
`;

const Modal = ({ close, chemicals, warnings }) => {
   const formatChemicals = () => {
      const singleChem = `${chemicals[0]} which is `;

      return chemicals.length === 1
         ? singleChem
         : `${chemicals.slice(0, -1).join(', ')}, and/or ${chemicals.slice(-1)} which are `;
   };

   return (
      <PopupContainer onClick={close}>
         <WarningHeader>
            <WarningContainer>
               <AlertTriangle />
               <span style={{ marginLeft: space[2] }}>WARNING</span>
            </WarningContainer>
            <Button>
               <Icon name="x" size={16} color={color.gray6} />
            </Button>
         </WarningHeader>
         <TextContainer>
            <p>
               This product can expose you to chemicals including {formatChemicals()}
               known to the State of California to cause {warnings}.
            </p>
            For more information, go to
            <br />
            <a target="_blank" href="https://www.P65Warnings.ca.gov">
               www.P65Warnings.ca.gov
            </a>
         </TextContainer>
      </PopupContainer>
   );
};

export default Modal;
